import type * as Types from '../../../../gql/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type StudentDiagnosticListFieldsFragment = { __typename?: 'StudentDiagnostic', id: string, diagnosticId: string, completedAt?: any | null, diagnostic: { __typename?: 'Diagnostic', id: string, name: string, guide: { __typename?: 'Guide', id: string, name: string, subject: { __typename?: 'Subject', id: string, name: string } } }, diagnosticSettings: { __typename?: 'DiagnosticSettings', startDate?: any | null, dueDate: any, endDate?: any | null } };

export type StudentDiagnosticsListQueryVariables = Types.Exact<{
  classroomIds?: Types.InputMaybe<Array<Types.Scalars['ID']['input']> | Types.Scalars['ID']['input']>;
}>;


export type StudentDiagnosticsListQuery = { __typename?: 'RootQueryType', studentDiagnostics?: { __typename?: 'KeysetPageOfStudentDiagnostic', results?: Array<{ __typename?: 'StudentDiagnostic', id: string, diagnosticId: string, completedAt?: any | null, diagnostic: { __typename?: 'Diagnostic', id: string, name: string, guide: { __typename?: 'Guide', id: string, name: string, subject: { __typename?: 'Subject', id: string, name: string } } }, diagnosticSettings: { __typename?: 'DiagnosticSettings', startDate?: any | null, dueDate: any, endDate?: any | null } }> | null } | null };

export const StudentDiagnosticListFieldsFragmentDoc = gql`
    fragment StudentDiagnosticListFields on StudentDiagnostic {
  id
  diagnosticId
  completedAt
  diagnostic {
    id
    name
    guide {
      id
      name
      subject {
        id
        name
      }
    }
  }
  diagnosticSettings {
    startDate
    dueDate
    endDate
  }
}
    `;
export const StudentDiagnosticsListDocument = gql`
    query StudentDiagnosticsList($classroomIds: [ID!]) {
  studentDiagnostics(filter: {enrolledViaClassroomId: {in: $classroomIds}}) {
    results {
      ...StudentDiagnosticListFields
    }
  }
}
    ${StudentDiagnosticListFieldsFragmentDoc}`;

/**
 * __useStudentDiagnosticsListQuery__
 *
 * To run a query within a React component, call `useStudentDiagnosticsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentDiagnosticsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentDiagnosticsListQuery({
 *   variables: {
 *      classroomIds: // value for 'classroomIds'
 *   },
 * });
 */
export function useStudentDiagnosticsListQuery(baseOptions?: Apollo.QueryHookOptions<StudentDiagnosticsListQuery, StudentDiagnosticsListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StudentDiagnosticsListQuery, StudentDiagnosticsListQueryVariables>(StudentDiagnosticsListDocument, options);
      }
export function useStudentDiagnosticsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StudentDiagnosticsListQuery, StudentDiagnosticsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StudentDiagnosticsListQuery, StudentDiagnosticsListQueryVariables>(StudentDiagnosticsListDocument, options);
        }
// @ts-ignore
export function useStudentDiagnosticsListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<StudentDiagnosticsListQuery, StudentDiagnosticsListQueryVariables>): Apollo.UseSuspenseQueryResult<StudentDiagnosticsListQuery, StudentDiagnosticsListQueryVariables>;
export function useStudentDiagnosticsListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<StudentDiagnosticsListQuery, StudentDiagnosticsListQueryVariables>): Apollo.UseSuspenseQueryResult<StudentDiagnosticsListQuery | undefined, StudentDiagnosticsListQueryVariables>;
export function useStudentDiagnosticsListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<StudentDiagnosticsListQuery, StudentDiagnosticsListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<StudentDiagnosticsListQuery, StudentDiagnosticsListQueryVariables>(StudentDiagnosticsListDocument, options);
        }
export type StudentDiagnosticsListQueryHookResult = ReturnType<typeof useStudentDiagnosticsListQuery>;
export type StudentDiagnosticsListLazyQueryHookResult = ReturnType<typeof useStudentDiagnosticsListLazyQuery>;
export type StudentDiagnosticsListSuspenseQueryHookResult = ReturnType<typeof useStudentDiagnosticsListSuspenseQuery>;
export type StudentDiagnosticsListQueryResult = Apollo.QueryResult<StudentDiagnosticsListQuery, StudentDiagnosticsListQueryVariables>;